import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";

function App() {

  const images = [
  "/images/pipe1.jpeg",
  "/images/pipe2.jpeg",
  "/images/pipe3.jpeg",
  "/images/pipe4.jpeg",
  "/images/pipe5.jpeg",
  "/images/pipe6.jpeg",
  "/images/pipe7.jpeg",
  "/images/pipe8.jpeg",
  "/images/pipe9.jpeg",
  "/images/pipe10.jpeg"
];

const [current, setCurrent] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setCurrent((prev) => (prev + 1) % images.length);
  }, 3000);

  return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const clients = [
  { name: "PATEL ENGINEERING LTD.", logo: "/clients/client1.png" },
  { name: "ATLANTA LIMITED", logo: "/clients/client2.png" },
  { name: "DRA-S&P(Joint Venture)", logo: "/clients/client3.png" },
  { name: "BSCPL INFRASTRUCTURE LTD.", logo: "/clients/client4.png" },
  { name: "M.G. Contractors Pvt. Ltd.", logo: "/clients/client5.png" },
  { name: "PNC Infratech Limited", logo: "/clients/client6.png" },
  { name: "NCC Limited", logo: "/clients/client7.png" }
];
const biharDistricts = [
  "Araria",
  "Arwal",
  "Aurangabad",
  "Banka",
  "Begusarai",
  "Bhagalpur",
  "Bhojpur",
  "Buxar",
  "Darbhanga",
  "East Champaran",
  "Gaya",
  "Gopalganj",
  "Jamui",
  "Jehanabad",
  "Kaimur",
  "Katihar",
  "Khagaria",
  "Kishanganj",
  "Lakhisarai",
  "Madhepura",
  "Madhubani",
  "Munger",
  "Muzaffarpur",
  "Nalanda",
  "Nawada",
  "Patna",
  "Purnia",
  "Rohtas",
  "Saharsa",
  "Samastipur",
  "Saran",
  "Sheikhpura",
  "Sheohar",
  "Sitamarhi",
  "Siwan",
  "Supaul",
  "Vaishali",
  "West Champaran"
];

 const [form, setForm] = useState({
  name: "",
  mobile: "",
  district: "",
  city: ""
});

  const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "mobile") {
    const onlyNums = value.replace(/[^0-9]/g, "");

    // First digit should be 6-9
    if (onlyNums.length === 1 && !/[6-9]/.test(onlyNums)) {
      return;
    }

    if (onlyNums.length <= 10) {
      setForm((prev) => ({
        ...prev,
        [name]: onlyNums
      }));
    }
  } else {
    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  }
};

  const submitForm = async (e) => {
    e.preventDefault();
   if (!/^[6-9][0-9]{9}$/.test(form.mobile)) {
    alert("❌ Please enter a valid 10 digit mobile number");
    return;
    }
    try {
      setLoading(true);

      await axios.post(`${process.env.REACT_APP_API_URL}/enquiry`, form);
	    
      alert("Enquiry submitted successfully 🚀");

      setForm({ name: "", mobile: "" });
      setShowPopup(false);

    } catch (error) {
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>

      {/* NAVBAR */}
      <div className="navbar">
        <div className="logo">RAJ PIPE INDUSTRIES</div>

        <div className="nav-links">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#products">Products</a>
          <a href="#clients">Clients</a>
          <a href="#certifications">Certifications</a>
          <a href="#contact">Contact</a>
        </div>
      </div>

      {/* HERO */}
      <div className="hero" id="home">

  <div className="slider">
    <img src={images[current]} alt="slider" />
  </div>

  <h1 className="brand-title">RAJ PIPE INDUSTRIES</h1>

  <p>Manufacturers of High Quality Hume Pipes, RCC Pipes & Concrete Products</p>

  <button onClick={() => setShowPopup(true)}>
    Get Free Quotation
  </button>

</div>

      {/* ABOUT */}
      <div className="section" id="about">
        <h2>About Us</h2>
       <p>
Raj Pipe Industries is a leading manufacturer of high-quality Hume Pipes, RCC Pipes, and concrete infrastructure products, committed to supporting India’s rapidly growing construction and infrastructure sector. With a strong focus on durability, precision engineering, and consistent quality, we deliver solutions that meet the demands of modern drainage, irrigation, and civil construction projects.
Our products are manufactured using premium-grade cement, aggregates, and reinforced steel, ensuring exceptional strength and long service life. RCC (Reinforced Cement Concrete) pipes are widely used in drainage systems, sewerage networks, culverts, and irrigation projects due to their ability to withstand heavy loads, environmental stress, and long-term usage without failure.
At Raj Pipe Industries, we follow advanced manufacturing processes in a controlled environment to maintain uniform quality and performance. Precast concrete pipes offer faster installation, reduced on-site labor, and improved efficiency in infrastructure development, making them a preferred choice in modern construction projects.
We are dedicated to delivering cost-effective and reliable solutions that support sustainable development. Our products are designed to be corrosion-resistant, low-maintenance, and capable of handling high-pressure flow, making them ideal for both government and private sector projects.
With a commitment to quality, timely delivery, and customer satisfaction, Raj Pipe Industries continues to build strong relationships with contractors, engineers, and infrastructure developers across the region. We aim to contribute to building stronger, smarter, and more durable infrastructure for the future.
</p>
      </div>

      {/* PRODUCTS */}
      <div className="section dark" id="products">

        <h2>Our Products</h2>

        <div className="grid">


          <Link
            to="/products/rcc"
            className="card product-card"
          >
            <h3>RCC Pipes</h3>
            <p>View Sizes & Details →</p>
          </Link>


          <Link
            to="/products/septic"
            className="card product-card"
          >
            <h3>Shankar Septic Tank</h3>
            <p>View Sizes & Details →</p>
          </Link>


          <Link
            to="/products/paver"
            className="card product-card"
          >
            <h3>Paver Concrete Blocks</h3>
            <p>View Sizes & Details →</p>
          </Link>

        </div>

      </div>
      
      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us</h2>
        <ul>
          <li>High Quality Raw Materials</li>
          <li>Durable & Long Life Products</li>
          <li>Affordable Pricing</li>
          <li>On-Time Delivery</li>
          <li>Trusted by Contractors</li>
        </ul>
      </div>


      {/* CLIENTS */}
<div className="section" id="clients">
  <h2>Our Clients</h2>

  <div className="clients-grid">
    {clients.map((client, index) => (
      <div className="client-card">{client.name}</div>
    ))}
  </div>
</div>

{/* CERTIFICATIONS */}
<div className="section" id="certifications">
  <h2>Our Certifications</h2>

  <div className="certificate-card">
    <a 
      href="/certifications/raj-pipe-iso.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="/certifications/raj-pipe-iso.png"
        alt="Raj Pipe Industries Certification"
      />
    </a>
    <p>Click image to view full certificate</p>
  </div>
</div>

      {/* CONTACT */}
      <div className="section" id="contact">
        <h2>Contact Us</h2>

        <p><strong>Registered Office:</strong><br/>
        Raj Pipe Industries,<br/>
        Vill.- Suara, P.O.- Pahleja<br/>
        Dehri, Rohtas, Bihar-821305</p>



        <p>📞 +91-7004630920</p>

        {/* WhatsApp Button */}
        <button 
          className="whatsapp-btn"
          onClick={() => window.open("https://wa.me/917004630920", "_blank")}
        >
          <img 
            src="https://cdn-icons-png.flaticon.com/512/733/733585.png" 
            alt="WhatsApp"
          />
          Chat on WhatsApp
        </button>
      </div>

      {/* FOOTER */}
      <div className="footer">
        <h3>RAJ PIPE INDUSTRIES</h3>
        <p>Hume Pipes | RCC Pipes | Concrete Products</p>

        <p>📍 Rohtas, Bihar</p>
        <p>📞 +91-7004630920</p>

        <p>© 2026 All Rights Reserved</p>
      </div>

      {/* POPUP */}
      {showPopup && (
        <div className="overlay">
          <div className="popup">

            <span className="close" onClick={() => setShowPopup(false)}>
              ×
            </span>

            <h2 className="popup-title">Enquiry Form</h2>
            <p className="popup-subtitle">Raj Pipe Industries</p>

            <form onSubmit={submitForm}>
              <input
                type="text"
                name="name"
                placeholder="Enter Name"
                value={form.name}
                onChange={handleChange}
                required
              />

              <input
                type="tel"
                name="mobile"
                placeholder="Enter Mobile Number"
                value={form.mobile}
                onChange={handleChange}
                required
              />
<select
  name="district"
  value={form.district}
  onChange={handleChange}
  required
>
  <option value="">Select District</option>

  {biharDistricts.map((district) => (
    <option key={district} value={district}>
      {district}
    </option>
  ))}
</select>


<input
  type="text"
  name="city"
  placeholder="Enter City"
  value={form.city}
  onChange={handleChange}
  required
/>

              <button type="submit">
                {loading ? "Submitting..." : "Submit"}
              </button>
            </form>

          </div>
        </div>
      )}


      {/* FLOATING JUSTDIAL BUTTON */}
<a 
  href="https://www.justdial.com/Dehri-On-Sone/Raj-Pipe-Industries-Near-By-Hawai-Adda-Village-Suara-Dehri-Bmp/9999P6188-6188-200615194024-L6U4_BZDET/"   // 👉 replace with your actual Justdial business link
  className="justdial-float" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <img 
    src="/images/justdial-logo.png"   // 👉 add Justdial logo in public/images
    alt="Justdial"
  />
</a>
      {/* FLOATING WHATSAPP BUTTON */}
      <a 
        href="https://wa.me/917004630920" 
        className="whatsapp-float" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <img 
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png" 
          alt="WhatsApp"
        />
      </a>

    </div>
  );
}

export default App;


